





















































































































































































































//store
import store from '@/store';

// vue
import { defineComponent, watch, onMounted, ref } from '@vue/composition-api';

// prime-vue
import Button from 'primevue/button';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Dialog from 'primevue/dialog';
import Confirm from '@/vue3/components/Confirm.vue';
import ProgressSpinner from 'primevue/progressspinner';
import InputSwitch from 'primevue/inputswitch';

// models
import { GeoRecord } from '@/vue3/api/models';

// components
import {
    Category,
    FileUpload,
    Measurement,
    Notes,
    Project,
    Task,
    Title,
    Model,
    Height,
    Label,
    Fill,
    MeasureLabel,
    Tags,
    Events,
} from '@/vue3/components/geo-record-editor';
import { Portal } from '@linusborg/vue-simple-portal';

// hooks
import { useGeoRecordDelete } from '@/vue3/hooks/geoRecordDeleteHook';
import { useNotify } from '@/vue3/hooks/notifyHook';

export default defineComponent({
    components: {
        Category,
        FileUpload,
        Measurement,
        Notes,
        Project,
        Task,
        Title,
        Model,
        Height,
        Label,
        Fill,
        MeasureLabel,
        Tags,
        Events,
        Button,
        Accordion,
        AccordionTab,
        InputSwitch,
        Portal,
        Dialog,
        Confirm,
        ProgressSpinner,
    },
    props: {
        selectedGeoRecordNames: {
            type: Array,
            default: () => [],
        },
        isMultipleGeomSelected: {
            type: Boolean,
            default: true,
        },
        cancelSelectByMultiTool: {
            type: Function,
            default: () => {},
        },
        startTranslate: {
            type: Function,
            default: () => {},
        },
        mapbox: {
            type: Object,
            default: () => {},
        },
        geoRecordsArray: {
            type: Array,
            default: () => [],
        },
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        categorySummaries: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isModifyAllowed: {
            type: Boolean,
            default: false,
        },
        changeDrawMode: {
            type: Function,
            default: () => {},
        },
        role: {
            type: Object,
            default: () => {},
        },
        layerTree: {
            type: Object,
            default: null,
        },
        toggleIsLoading: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // hooks
        const { deleteGeoRecordLayer } = useGeoRecordDelete();
        const { errorToast } = useNotify();

        // refs
        const geoRecordTemp = ref<GeoRecord>({
            id: 1,
            title: '',
            notes: '',
            isFill: true,
            projectId: 0,
            labelState: '',
            geoRecordCategoryId: 0,
            geoRecordModelId: 0,
            isTask: false,
            assigneeAccountId: 0,
            statusId: 0,
            startDate: null,
            endDate: null,
            dueDate: null,
            archiveEventId: 0,
            isPrivate: false,
        } as GeoRecord);

        const isDeleteVisible = ref<boolean>(false);
        const showVisibility = ref<boolean>(false);

        // watchers

        watch(
            () => props.geoRecordsArray,
            () => {
                showVisibility.value = props.geoRecordsArray.every(
                    (geoRecord) =>
                        geoRecord.accountId === store.getters.account.id,
                );
            },
        );

        // methods
        const saveGeoRecordTemp = () => {
            geoRecordTemp.value.tagIds = [];
            props.geoRecordsArray.forEach((geoRecord) => {
                if (geoRecordTemp.value.title !== '') {
                    geoRecord.title = geoRecordTemp.value.title;
                }
                if (geoRecordTemp.value.notes !== '') {
                    geoRecord.notes = geoRecordTemp.value.notes;
                }
                if (geoRecordTemp.value.geoRecordCategoryId !== 0) {
                    geoRecord.geoRecordCategoryId =
                        geoRecordTemp.value.geoRecordCategoryId;
                }
                if (geoRecordTemp.value.labelState !== '') {
                    geoRecord.labelState = geoRecordTemp.value.labelState;
                }
                if (geoRecordTemp.value.projectId !== 0) {
                    geoRecord.projectId = geoRecordTemp.value.projectId;
                }
                if (geoRecordTemp.value.geoRecordModelId !== 0) {
                    geoRecord.geoRecordModelId =
                        geoRecordTemp.value.geoRecordModelId;
                }
                if (geoRecordTemp.value.isTask) {
                    geoRecord.isTask = geoRecordTemp.value.isTask;
                }
                if (geoRecordTemp.value.startDate) {
                    geoRecord.startDate = geoRecordTemp.value.startDate;
                }
                if (geoRecordTemp.value.dueDate) {
                    geoRecord.dueDate = geoRecordTemp.value.dueDate;
                }
                if (geoRecordTemp.value.endDate) {
                    geoRecord.end = geoRecordTemp.value.endDate;
                }
                if (geoRecordTemp.value.assigneeAccountId !== 0) {
                    geoRecord.assigneeAccountId =
                        geoRecordTemp.value.assigneeAccountId;
                }
                if (geoRecordTemp.value.archiveEventId !== 0) {
                    geoRecord.archiveEventId =
                        geoRecordTemp.value.archiveEventId;
                }
                if (geoRecordTemp.value.tagIds.length > 0) {
                    geoRecord.tagIds = geoRecordTemp.value.tagIds;
                }
                if (geoRecordTemp.value.isPrivate) {
                    geoRecord.isPrivate = geoRecordTemp.value.isPrivate;
                }

                geoRecord.isFill = geoRecordTemp.value.isFill;
            });

            props.saveGeoRecord();
            props.changeDrawMode();
        };

        const toggleIsDeleteVisible = () => {
            isDeleteVisible.value = !isDeleteVisible.value;
        };

        const setIsPrivate = (): void => {
            geoRecordTemp.value.isPrivate = !geoRecordTemp.value.isPrivate;
        };

        const clearSelection = (): void => {
            props.cancelSelectByMultiTool();
            props.changeDrawMode();
        };

        const confirmDecline = () => {
            toggleIsDeleteVisible();
        };

        const confirmDeleteGeoRecord = async () => {
            props.toggleIsLoading(true);
            let limit = 10;
            const geoRecordIds = props.geoRecordsArray.map(
                (record) => record.id,
            );

            try {
                if (geoRecordIds.length <= limit) {
                    props.geoRecordsArray.forEach(async (geoRecord: any) => {
                        await deleteGeoRecordLayer(props.mapbox.map, geoRecord);
                    });

                    clearSelection();

                    await props.layerTree.refreshGeoRecordTreeAndState(
                        geoRecordIds,
                        false,
                    );
                } else {
                    errorToast(
                        `Cannot delete more than ${limit} records in one request`,
                    );
                }
            } catch (error) {
                window.console.log(error);
            }

            toggleIsDeleteVisible();

            props.toggleIsLoading(false);
        };

        const handleGeoRecordPropertyUpdate = (geoRecordProperties = {}) => {
            geoRecordTemp.value = {
                ...geoRecordTemp.value,
                ...geoRecordProperties,
            };
            return geoRecordTemp.value;
        };

        // lifecycle
        onMounted(() => {
            showVisibility.value = props.geoRecordsArray.every(
                (geoRecord) => geoRecord.accountId === store.getters.account.id,
            );
        });

        return {
            showVisibility,
            geoRecordTemp,
            handleGeoRecordPropertyUpdate,
            saveGeoRecordTemp,
            clearSelection,
            setIsPrivate,
            toggleIsDeleteVisible,
            isDeleteVisible,
            confirmDecline,
            confirmDeleteGeoRecord,
        };
    },
});
